 


import type { RouteObject } from 'react-router';
import { lazyRoute } from '../utils/lazyRoute.js';

const payrollRoutes: RouteObject[] = [
  {
    path: 'PAY/*',
    children: [
      { path: 'HomePage', lazy: lazyRoute(() => import('../../pages/HR/payroll/Main/Main.jsx')) },

      { path: 'Payrolls', lazy: lazyRoute(() => import('../../pages/HR/payroll/payroll/payroll.jsx')) },

      { path: 'payrolls/:id/ElementLink', lazy: lazyRoute(() => import('../../pages/HR/payroll/ElementLink/ElementLink.jsx')) },

      { path: 'PayrollElement', lazy: lazyRoute(() => import('../../pages/HR/payroll/payrollElement/PayrollElement.jsx')) },

      {
        path: 'PayrollElement/:id/EditElementType',
        lazy: lazyRoute(() => import('../../pages/HR/payroll/payrollElement/EditElementType.jsx'))
      },

      { path: 'payrollsRun', lazy: lazyRoute(() => import('../../pages/HR/payroll/PayrollRun/PayrollRun.jsx')) },

      { path: 'payrollsRun/:payrollId/AddRun', lazy: lazyRoute(() => import('@pages/HR/payroll/PayrollRun/AddRun.jsx')) },

      { path: 'ShowPayrollRun', lazy: lazyRoute(() => import('../../pages/HR/payroll/ShowPayrollRun/ShowPayrollRun.jsx')) },

      {
        path: 'ShowPayrollRun/:PayrollActionId/AssignmentActionList',
        lazy: lazyRoute(() => import('../../pages/HR/payroll/ShowPayrollRun/AssignmentAction.jsx'))
      },

      { path: 'QuickPay', lazy: lazyRoute(() => import('../../pages/HR/payroll/PayrollRun/QuickPay.jsx')) },

      { path: 'Banks', lazy: lazyRoute(() => import('../../pages/NTX/Banks/Index.js')) },

      { path: 'PayrollElementEntry', lazy: lazyRoute(() => import('../../pages/HR/payroll/PayrollElementEntry/PayrollElementEntry.jsx')) },

      {
        path: 'PayrollElementEntry/:assignmentId/:payrollId/AddElementEntry',
        lazy: lazyRoute(() => import('../../pages/HR/payroll/PayrollElementEntry/AddElementEntry.jsx'))
      },

      {
        path: 'PayrollElementEntry/:assignmentId/AddPayProposal',
        lazy: lazyRoute(() => import('../../pages/HR/payroll/PayProposal/AddPayProposal.jsx'))
      },

      // Reports
      {
        path: 'Reports/*',
        children: [
          { path: '*', lazy: lazyRoute(() => import('../../pages/HR/payroll/Reports/PayrollReports.js')) },
          {
            path: ':ReportId/ReportsBuilder',
            lazy: lazyRoute(() =>
              import('../../pages/NTX/Reports/ReportsAllByModule/Reports/ReportsBuilder/ReportsBuilder.js')
            )
          }
        ]
      },

      // Dashboard
      {
        path: 'Dashboard/*',
        children: [
          { path: '*', lazy: lazyRoute(() => import('../../pages/HR/payroll/Dashboard/PayrollDashboard.js')) },
          {
            path: ':dashboardId/BuilderDashboard',
            lazy: lazyRoute(() =>
              import('../../pages/NTX/DashboardManagament/BuilderDashboard/BuilderDashboard.jsx')
            )
          }
        ]
      }
    ]
  }
];

export default payrollRoutes;
